import type { UseModalDetailsCarouselReturn } from '.';

export function useModalDetailsCarousel(): UseModalDetailsCarouselReturn {
	const isCarouselOpen = ref(false);
	const currentCarouselItemIndex = ref(0);
	const imagesEl = ref<HTMLElement | null>(null);
	const imagesScrollPosition = ref(0);
	const lastImagesScrollPosition = ref(0);

	const showCarousel = (index: number) => {
		isCarouselOpen.value = true;
		currentCarouselItemIndex.value = index;
		if (imagesEl.value) {
			lastImagesScrollPosition.value = imagesEl.value.scrollTop;
		}
	};

	watch(
		() => isCarouselOpen?.value,
		newValue => {
			if (!newValue) {
				currentCarouselItemIndex.value = 0;
			}
		}
	);

	return {
		isCarouselOpen,
		currentCarouselItemIndex,
		imagesEl,
		showCarousel,
		imagesScrollPosition,
		lastImagesScrollPosition
	};
}
